<template>
  <div class="app-container">
    <h2 style="marginbottom: 10px">预告标题: {{ liveAdvanceNoticeTitle }}</h2>
    <div class="header">
      <div class="search" style="search-select;">
        <el-select
          v-model="searchuserId"
          filterable
          placeholder="请选择发布人"
          style="marginright: 10px"
        >
          <el-option label="全部" value="all"> </el-option>
          <el-option
            v-for="item in createrList"
            :key="item.userId"
            :label="item.nickName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
        <el-button icon="el-icon-search" size="small" @click="onSearch"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh" size="small" @click="onRefresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="onRemove"
            >批量删除</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      height="750"
      :data="tableData"
      element-loading-text="loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="100" label="动态图片">
        <template slot-scope="scope">
          <img :src="scope.row.photo" style="width: 100%" />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="200"
        label="动态正文"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.contents }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="动态备注">
        <template slot-scope="scope">
          {{ scope.row.remark }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center"  label="创建人"  >
                <template slot-scope="scope">
                    {{scope.row.nickName}}
                </template>
            </el-table-column>
            <el-table-column align="center"  label="创建时间" prop="createTime" sortable>
                <template slot-scope="scope">
                    {{scope.row.createTime}}
                </template>
            </el-table-column> -->

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="edit(scope)"
            >编辑</el-button
          >
          <el-button type="text" size="mini" @click="deleteNews(scope)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination ref="Pagination" />

    <editForm ref="editForm" />
  </div>
</template>

<script>
const editForm = () => import('./editForm');
import Pagination from '@/components/Pagination';
import {
  getAdvanceContentList,
  getAdvanceContent,
  removeAdvanceContent,
} from '@/api/live.js';
import { getAllUsers } from '@/api/allUser.js';

import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination,
    editForm,
  },
  inject: ['reload'],

  data() {
    return {
      path: '',
      listLoading: false,
      tableData: [],
      createrList: [],
      liveAdvanceNoticeId: '',
      liveAdvanceNoticeTitle: '',
      searchuserId: '',
      pageIndex: 1,
      pageSize: 10,
      multipleSelection: [],
      houseData: [],
      selectValue: '',
      selectLabel: '',
    };
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');

    this.path = arr[arr.length - 1].split('?')[0];
    // console.log(this.path, 'lalal', this.roleList);
  },
  mounted() {
    this.liveAdvanceNoticeId = this.$route.query.id;
    this.liveAdvanceNoticeTitle = this.$route.query.title;
    this.getList();
  },
  watch: {
    paginObj: 'getList',
  },
  methods: {
    async getList() {
      this.listLoading = true;

      await getAdvanceContentList({
        liveAdvanceNoticeId: this.liveAdvanceNoticeId,
        userId: this.searchuserId,
        //name: this.formInline.name,
        pageIndex: this.paginObj.pageIndex,
        pageSize: this.paginObj.pageSize,
      }).then((res) => {
        this.tableData = res.data.dataList;
        this.listLoading = false;
        this.pageIndex = res.data.pageIndex;
        this.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageIndex = res.data.pageIndex;
        this.$refs.Pagination.pageSize = res.data.pageSize;
        this.$refs.Pagination.totalCount = res.data.totalCount;
      });
      try {
        await getAllUsers().then((res) => {
          this.createrList = res.data;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //搜索
    onSearch() {
      if (this.searchuserId === 'all') {
        this.searchuserId = '';
      }
      this.getList();
    },
    //刷新
    onRefresh() {
      this.reload();
    },
    //新增
    onAdd() {
      this.$refs.editForm.dialogTitle = '新增预告动态';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.liveAdvanceNoticeId = this.liveAdvanceNoticeId;
    },

    //编辑
    edit(scope) {
      this.$refs.editForm.dialogTitle = '编辑预告动态';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.liveAdvanceNoticeId = scope.row.liveAdvanceNoticeId;
      this.$refs.editForm.liveAdvanceContentId = scope.row.liveAdvanceContentId;
      getAdvanceContent(scope.row.liveAdvanceContentId).then((res) => {
        this.$refs.editForm.editForm = res.data;
      });
    },
    //批量删除
    onRemove() {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.liveAdvanceContentId);
      });
      this.funcRemove(checkIds);
    },
    //单条删除
    deleteNews(scope) {
      let checkIds = [];
      checkIds.push(scope.row.liveAdvanceContentId);
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0) {
          return this.$message.error('请选择要删除的数据！');
        }
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await removeAdvanceContent(checkIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
</style>
